import { Icon } from "semantic-ui-react";
import { options, optionsAsLabel, optionsForDate } from "../GanttInfoRenderer";
import { AbstractInfoRenderer } from "./AbstractInfoRenderer";

export class TaskInfoRenderer extends AbstractInfoRenderer {

    static defaultProps = {
        entityName: "Task"
    }

    renderContent() {
        const { entity } = this.props;
        const ed = this.getEntityDescriptor();
        return <div className="flex-container-row flex-center gap3">
            {ed.getField("taskType").renderField(entity, optionsAsLabel)}
            {ed.getField("name").renderField(entity, options)}
            {ed.getField("quantity").renderField(entity, options)}
            {ed.getField("offloadStatus").renderField(entity, options)}
            {ed.getField("startAddress").renderField(entity, options)}
            {ed.getField("actualStartTime").renderField(entity, optionsForDate)}
            <div><Icon name="arrow right" /></div>
            {ed.getField("endAddress").renderField(entity, options)}
            {ed.getField("actualEndTime").renderField(entity, optionsForDate)}
            {ed.getField("requiredEquipmentResourceQualificationType").renderField(entity, options)}
            {ed.getField("equipmentResourceFillPercentage").renderField(entity, options)}
            {ed.getField("comment").renderField(entity, options)}
        </div>
    }
}
